// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"7020cf48","513":"4c4d63d6","703":"930ae725","787":"31e0d78d"}[chunkId] + ".chunk.js";
};